export default {"src":"/_next/static/media/notch.e098274a.svg","height":45,"width":103,"blurWidth":0,"blurHeight":0};